import request from "@/utils/request";

export function listStuCurriculum(query) {
  return request({
    url: "/stuc/stucurriculum/list",
    method: "get",
    params: query,
  });
}

export function getStuCurriculum(id) {
  return request({
    url: "/stuc/stucurriculum/get?id=" + id,
    method: "get",
  });
}

export function addStuCurriculum(data) {
  return request({
    url: "/stuc/stucurriculum/add",
    method: "post",
    data: data,
  });
}

export function editStuCurriculum(data) {
  return request({
    url: "/stuc/stucurriculum/edit",
    method: "post",
    data: data,
  });
}

export function delStuCurriculum(ids) {
  return request({
    url: "/stuc/stucurriculum/del",
    method: "post",
    data: {
      ids: ids,
    },
  });
}

export function stuCurriculumTemplate() {
  return `/stuc/stucurriculum/importTemplate`;
}

export function stuCurriculumImport(mid, rows, opts) {
  var data = {
      mid,
      options: JSON.stringify(opts),
      rows: JSON.stringify(rows)
  }

  return request({
      url: "/stuc/stucurriculum/import/" + mid,
      method: 'post',
      data: data
  })

};

export function stuCurriculumExportUrl(mid, query,fieldlist) {
  var data = {
      page: query.pageNum,
      psize: query.pageSize,
      qstr: {},
      fieldlist:Array.isArray(fieldlist)?fieldlist.join("|"):fieldlist
  }

  var tjson = ReFormatQueryStr(query)
  data.qstr = JSON.stringify(tjson)

  var parata=[]
  for(let i in data){
      parata.push(i+"="+data[i])
  }

  return   `/stuc/stucurriculum/export?` + parata.join("&") ;
};
